export const jobPostings = [
  {
    jobPostingDate: "2023-08-19",
    companyName: "TechCo",
    jobTitle: "Software Engineer",
    companyIcon: "https://example.com/company-icon.png",
    jobTags: ["React", "JavaScript", "Web Development"],
    jobRate: "$70 /hr",
    jobLocation: "San Francisco, CA",
  },
  {
    jobPostingDate: "2023-08-18",
    companyName: "FinanceCorp",
    jobTitle: "Financial Analyst",
    companyIcon: "https://example.com/finance-icon.png",
    jobTags: ["Finance", "Analysis", "Data"],
    jobRate: "$120 /hr",
    jobLocation: "New York, NY",
  },
  {
    jobPostingDate: "2023-08-17",
    companyName: "DesignStudio",
    jobTitle: "Graphic Designer",
    companyIcon: "https://example.com/design-icon.png",
    jobTags: ["Design", "Creative", "Adobe"],
    jobRate: "$85 /hr",
    jobLocation: "Los Angeles, CA",
  },
  {
    jobPostingDate: "2023-08-16",
    companyName: "HealthTech",
    jobTitle: "Data Scientist",
    companyIcon: "https://example.com/health-icon.png",
    jobTags: ["Data Science", "Machine Learning", "Healthcare"],
    jobRate: "$90 /hr",
    jobLocation: "Boston, MA",
  },
  {
    jobPostingDate: "2023-08-15",
    companyName: "EcoSolutions",
    jobTitle: "Environmental Scientist",
    companyIcon: "https://example.com/environment-icon.png",
    jobTags: ["Environmental", "Research", "Sustainability"],
    jobRate: "$55 /hr",
    jobLocation: "Seattle, WA",
  },
];
